if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    const sectionId = data?.sectionId;
    const variant = data?.variant;

    if (!sectionId || !variant) return;

    const productInfo = Array.from(document.querySelectorAll('product-info')).find(
      (element) =>
        element.dataset.section === sectionId ||
        element.dataset.originalSection === sectionId
    );

    if (!productInfo) return;

    const addToCartButton = productInfo.querySelector(
      'button[id^="ProductSubmitButton-"]'
    );

    const backInStockButton = productInfo.querySelector(
      '[data-afrishon-bis-trigger]'
    );

    if (!addToCartButton || !backInStockButton) return;

    const isSoldOut = variant.available === false;

    addToCartButton.classList.toggle('hidden', isSoldOut);
    backInStockButton.classList.toggle('hidden', !isSoldOut);

    backInStockButton.setAttribute(
      'aria-hidden',
      isSoldOut ? 'false' : 'true'
    );
  });
}